import { takeEvery, put, all } from 'redux-saga/effects'
import { GET_PSINFOR_LIST } from './actionTypes'
import * as actionCreators from './actionCreators'
import { getPsInfoByUserId, getRidesPsInfoAliasName } from '../../../../../request/api'
import cookie from 'react-cookies'

/**
 * 功能：注册电站列表相关的 saga 监听器。
 * 参数含义：无。
 * 返回值：返回 saga 监听任务。
 * 异常 / 注意事项：该方法只负责监听动作，不直接处理页面展示逻辑。
 */
function* saga() {
    yield all([
        yield takeEvery(GET_PSINFOR_LIST, fetchSearchList),
    ])
}

/**
 * 功能：加载当前用户的电站列表，并初始化默认选中的电站信息。
 * 参数含义：无。
 * 返回值：无，处理结果会通过 Redux action 写入全局状态。
 * 异常 / 注意事项：必须先写入默认电站信息，再结束 loading，避免首页在站型未确认时误渲染错误页面。
 */
function* fetchSearchList() {
    const userId = cookie.load('userId')
    const psId = window.sessionStorage.getItem('psId')
    let actionPsinfo = null
    let actionDefault = null

    try {
        const res = yield getPsInfoByUserId(userId)
        if (res.status === 200) {
            const data = Array.isArray(res.data) ? res.data : []

            // 这里先处理别名，是为了保证后续排序和默认展示使用的都是最终名称。
            const ret = yield getRidesPsInfoAliasName(userId)
            const ridesPsInfoAlias = ret.data
            if (ridesPsInfoAlias !== null) {
                ridesPsInfoAlias.forEach(alias => {
                    data.forEach(item => {
                        if (alias.psId === item.psId && alias.aliasName !== '') {
                            item.psName = alias.aliasName
                        }
                    })
                })
            }

            // 统一按电站名称排序，保证刷新后默认电站和下拉列表顺序稳定。
            data.sort(function (a, b) {
                return a.psName.localeCompare(b.psName)
            })

            if (data.length > 0) {
                if (psId !== null) {
                    data.forEach(item => {
                        // 优先恢复用户上次选择的电站，避免刷新后跳到其他电站。
                        if (item.psId === psId) {
                            actionPsinfo = actionCreators.setPsinfo(item)
                            actionDefault = actionCreators.selectPs(item.psId)
                        }
                    })
                }

                // 当 session 中没有电站，或者历史电站已失效时，回退到排序后的首个电站。
                if (actionPsinfo === null || actionDefault === null) {
                    actionPsinfo = actionCreators.setPsinfo(data[0])
                    actionDefault = actionCreators.selectPs(data[0].psId)
                }

                // 先写入当前电站信息，再结束 loading，避免首页根据空 psType 误渲染普通电站页面。
                yield put(actionPsinfo)
                yield put(actionDefault)
            }

            yield put(actionCreators.setPsInfoList(data))
        } else if (res.status === 503) {
            // window.location.href='/'
            // const urlRoute = useNavigate();
            // urlRoute("/")
        }
    } catch (e) {
        console.log('请求失败')
    }
}

export default saga
